import React from "react";
import _get from "lodash/get";
import { withRouter } from "react-router-dom";
import { withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RoleForm from "./RoleForm";
import EditUserForm from "./EditUserForm";
import { getAdminScopes } from "../../actions/adminDashActions";
import { LABELS as _LABELS } from "../../language";

const LABELS = _LABELS.adminPage;

const styles = (theme) => ({
  wrapper: {},
  DialogActions: {
    marginTop: 20,
  },
  AlignCenter: {
    textAlign: "center",
    display: "flex",
    justifyContent: "space-evenly",
  },
  AlignBtn: {
    textAlign: "center",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  agriExm: {
    border: "1px solid grey",
    textTransform: "uppercase",
    flexBasis: "25%",
    flexShrink: 0,
    padding: 4,
    backgroundColor: "white",
    textAlign: "center",
    color: "black",
    display: "inline-block",
    width: 110,
    borderRadius: 5,
    fontWeight: 500,
  },
});

export function formatScopes(props) {
  const scopes = props.scopes || [];
  let all = {};

  for (let i = 0; i < scopes.length; i++) {
    const item = scopes[i];
    const name = item.name;
    const keyName = name.split("_")[1];
    all[keyName] = all[keyName] || {};
    all[keyName].items = all[keyName].items || [];
    all[keyName].items.push(item);
  }

  return Object.keys(all).map((item) => {
    return {
      name: item,
      data: all[item].items,
    };
  });
}

export class EditUserModal extends React.Component {
  state = {
    loading: false,
    message: "",
  };

  async componentDidMount() {
    await this.getScopes();
  }

  getScopes = async () => {
    const _scopes = await this.props.getAdminScopes();
    if (_scopes) {
      const scopes = formatScopes({
        selected: this.props.selected,
        scopes: _scopes,
      });
      this.setState({ scopes });
    }
  };

  render() {
    const { classes } = this.props;
    const isSmallScreen = window.innerWidth < 500;
    const isAdmin = _get(this, "props.selected.role") === "ADMIN";
    return (
      <Dialog
        fullScreen={isSmallScreen}
        fullWidth={true}
        maxWidth={"xl"}
        className={classes.wrapper}
        open={!!this.props.open}
        onClose={this.props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" onClose={this.props.handleClose}>
          <Typography>{LABELS.edit_User}</Typography>
          <IconButton
            aria-label="Close"
            className={classes.closeButton}
            onClick={this.props.handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <EditUserForm
            selected={this.props.selected}
            allScopes={this.state.scopes}
            handleClose={this.props.handleClose}
          />
          {isAdmin && <Typography>{"Edit Access"}</Typography>}
          <RoleForm
            selected={this.props.selected}
            allScopes={this.state.scopes}
            handleClose={this.props.handleClose}
          />
        </DialogContent>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    constants: _get(state, "appData.constants", {}),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getAdminScopes }, dispatch);

export default withStyles(styles)(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(EditUserModal))
);
